import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { DISCOUNT_CODE_PATH } from '../../../../config/paths';
import DiscountCodeDeleteButton from './DiscountCodeDeleteButton';

const DiscountCodeToolbar = ({ discountCodeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${DISCOUNT_CODE_PATH}/${discountCodeId}/edit`} />{' '}
      <DiscountCodeDeleteButton discountCodeId={discountCodeId} />
    </div>
  </ButtonToolbar>
);

DiscountCodeToolbar.propTypes = {
  discountCodeId: PropTypes.number.isRequired,
};

export default DiscountCodeToolbar;
